import '../../MapStyles/MapColorPicker.scss';
import { Button } from 'react-bootstrap';

export function MapColorPicker({ setObjColor }) {
  const colors = [
    '#ff4b4b', // Red
    '#ff914d', // Orange
    '#ffe34d', // Yellow
    '#90e44d', // Green
    '#4de4b0', // Aqua/Teal
    '#0048ff', // Blue
    '#824dff', // Indigo
    '#b44dff', // Violet
    '#f178b6', // Pink
    '#808080', // Gray
  ];

  return (
    <div className="grid-container">
      {colors.map((color, index) => (
        <Button
          key={index}
          className="color-container"
          variant="light"
          onClick={() => setObjColor(color)}
        >
          <div className="circle-button" style={{ backgroundColor: `${color}` }} />
        </Button>
      ))}
    </div>
  );
}
